module.exports = __webpack_public_path__ + "static/media/marina.8f3cd7c6.svg";